import { client } from './api';

const ENDPOINT = 'user/notificationsFrequency';

class NotificationService {
  currentNotificationFriquency = async () => {
    const response = await client.get(ENDPOINT);
    return response;
  };

  updateNotificationFriquency = async friquency => {
    const response = await client.patch(ENDPOINT, friquency);
    return response;
  };
}

export default NotificationService;
